let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kfrHX")).then(() => parcelRequire('bdGVV'));